export default __webpack_public_path__ + "static/media/loading.615a5139.gif";